const SCREENS = Object.freeze({
  DASHBOARD: 'Dashboard',
  SUMMARY: 'Summary',
  MOVE: 'Move Loose Items'
});

export { SCREENS };
